<template>
  <div class="middle cadfm-flexitem-stretched">
    <action-panel>
      <action-bar>
        <b-navbar-nav>

          <action-button @click="back" icon="back" bold :text="lang.button_Back" :tooltip="lang.button_Back"
            :disabled="backButtonStatus" />
          <action-button @click="save" icon="save" bold :text="lang.button_Save"
            :tooltip="lang.button_Save" :disabled="saveButtonStatus" />



        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <action-button v-show="!$parent.isVisibleLeft" @click="toggleLeftPanel" icon="show" bold
            :text="lang.button_Left" :tooltip="lang.button_Left" :disabled="false" />
          <action-button v-show="!$parent.isVisibleRight" @click="toggleRightPanel" icon="show" bold
            :text="lang.button_Right" :tooltip="lang.button_Right" :disabled="false" />

        </b-navbar-nav>
      </action-bar>
      <action-content>
        <Content :lang="lang.Content"></Content>
      </action-content>
    </action-panel>
  </div>
</template>

<script>
  import ActionBar from '@/components/shared/ActionBar'
  import ActionButton from '@/components/shared/ActionButton'
  import ActionContent from '@/components/shared/ActionContent'
  import ActionPanel from '@/components/shared/ActionPanel'


  import Content from "@/components/PartManager/Views/PartDerive/Middle/Content/Content"



export default {
  name: 'Middle',
  components:{
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    Content

  },
  props:{
    lang: Object
  },
  data () {
    return {

      saveButtonStatus: false,
      backButtonStatus: false,
      saving: false,
    }
  },
  computed:{
    blockCreateOver1Level() {
      if (this.$store.getters.selectedTreeItemObject.depth > 1) {
        this.saveButtonStatus = false;
        return true;
      } else {
        this.saveButtonStatus = true;
        return false;
      }
    },

  },
  watch: {
    blockCreateOver1Level: function () {

    }
  },
  created() {


  },
  methods: {
    save(){
      

        let trig = false;
        for (let i = 0, lei = this.$store.getters.propertyToSaving.length; i < lei; i++){
                

          if ((this.$store.getters.propertyToSaving[i].isRequiredOnRequest == true) && (this.$store.getters.propertyToSaving[i].value == "") && (this.$store.getters.propertyToSaving[i].type != "part number")) {
            
            trig = true;
            break;
          }
        }

        if (trig == true){
          let obj = {
            text: this.lang.alert_error_new_part_required,
            time: 10,
            type: "danger"
          }

          this.$store.dispatch("displayFooterAlert", obj);
        }else{

          let distributorPartId = this.$store.getters.selectedSearchedRows.DistributorPartId==undefined?"":this.$store.getters.selectedSearchedRows.DistributorPartId;

          

          if(this.$route.query.from != "/PartManager/PartSearch"){
            distributorPartId == "";
          }

          let obj = {
            categoryId: this.$store.getters.selectedTreeItemObject.categoryId,
            values: this.$store.getters.propertyToSaving,
            distributorPartId: distributorPartId
          }

          let vue = this;
          
          this.$store.dispatch(this.$store.getters.sectionPrefix + "_createNewPart", obj)
          .then(function(result){

            console.log(result)

            

            if (result.status == "OK"){

              if (result.data != null){

                let goalObj = result.data;

                const obj = {
                  revisionId: goalObj.revisionId,
                  categoryId: vue.$store.getters.selectedTreeItemObject.categoryId,
                  values: vue.$store.getters.derivedNewProps
                }
             

                vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_createNewPropertyFromFound", obj)
                .then(function (result) {
                  
                  console.log(result)

                  if (result.status == "OK"){

                    const obj = {
                      text: vue.lang.alert_success_new_part,
                      time: 5,
                      type: "success"
                    }

                    vue.saving = true;

                    vue.$store.dispatch("displayFooterAlert", obj);

                    
                    vue.toDetails(goalObj);
                    

                  }else{
                    const obj = {
                      text: vue.lang.alert_error_new_props,
                      time: 10,
                      type: "danger"
                    }

                    vue.$store.dispatch("displayFooterAlert", obj);
                  }
                })



              }else{
                const obj = {
                  text: vue.lang.alert_error_new_part + ".",
                  time: 15,
                  type: "danger"
                }

                vue.$store.dispatch("displayFooterAlert", obj);
              }

              


              

            }else{
              const obj = {
                text: vue.lang.alert_error_new_part + ": " + result.message,
                time: 15,
                type: "danger"
              }

              vue.$store.dispatch("displayFooterAlert", obj);


            }


          })

          }


    },
    toDetails(goalObj){
      this.$store.dispatch("resetPropertyToSaving");

      this.$store.dispatch("deleteAllSelectedRows");

      let to = "/PartManager/PartDetails";

      let obj = {
        col___revisionId: {
          revisionId: goalObj.revisionId,
          partId: goalObj.partId
        },
        col___revision: {
          revisionId: 1
          
        },
        col___status: {
          assembly: false
          
        }
      }

      this.$store.dispatch("setSelectedRows", [obj]);
      
      this.$store.dispatch("setOuterData", true);

      this.$store.dispatch("editPropertiesForm", false);

      
      

      
      const query = {
        from: this.$route.path,
        to: to,
        end: true,
        revisionId: goalObj.revisionId,
        id: goalObj.partId
      }

      this.$router.push({ path: to, query: query })      

    },
    back(){
    
      this.$store.dispatch("setSaveStatus", false);
      this.$store.dispatch("resetPropertyToSaving");

      if (this.saving){
        
        const reloadObj = {
            status: true,
            name: "DataTableFilteredOnApiComponent"
        }
        this.$store.dispatch("reloadAfterActionComplex", reloadObj);
        

      }
      let to = this.$route.query.from;

      

      
      const query = {
        from: this.$route.path,
        to: to,
        revisionId: this.$route.query.revisionId,
        id: this.$route.query.id
      }

      this.$router.push({ path: to, query: query })     
    },
    toggleRightPanel(){
      
      this.$parent.isVisibleRight = !this.$parent.isVisibleRight;
      
    },
    toggleLeftPanel(){
      
      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;
      
    }
  }
}
</script>


<style scoped>

  .middle{
    border-right: 1px solid #666;
  }

</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/PartDerive/Middle/Middle.vue